import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Detect Windows OS and apply platform-windows class to html element
if (typeof navigator !== "undefined" && typeof document !== "undefined") {
  const isWindows = /Windows|Win32|Win64/i.test(navigator.userAgent || navigator.platform);
  if (isWindows) {
    document.documentElement.classList.add("platform-windows");
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// Prevent mouse scroll wheel from accidentally changing number input values globally
if (typeof document !== "undefined") {
  document.addEventListener(
    "wheel",
    () => {
      if (document.activeElement?.type === "number") {
        document.activeElement.blur();
      }
    },
    { passive: true },
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
